module.exports = __webpack_public_path__ + "static/awscloud-9de1b80fd0bc51c26f367e9bbdeadf20.png";